import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import OperatorTailReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/operator-tail.duck';

// We need to do this to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(OperatorTailReducer, defaultState, asyncActions);
};

type IOperatorTailContext = ReturnType<typeof useReducer>;

// Having  trouble setting initial values, that's why it is case to the return type of the reducer
const OperatorTailContext = createContext<Partial<IOperatorTailContext>>({
  state: defaultState,
}) as React.Context<IOperatorTailContext>;

const OperatorTailProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <OperatorTailContext.Provider value={{ ...reducer }}>
      {children}
    </OperatorTailContext.Provider>
  );
};

// We create context hook here so that we can be able to unit test
// container components taht uses this context
export const useOperatorTailContext = () => useContext(OperatorTailContext);

export type IUseOperatorTailContext = ReturnType<typeof useOperatorTailContext>;

export { OperatorTailContext, OperatorTailProvider };
